import { femaleAvatar, maleAvatar, unknownAvatar } from '../../assets/images'
import { GENDER } from '../../helpers'
// eslint-disable-next-line import/no-cycle -- comment: Will fix when we impliment frontier printing
import { useTree } from '../useTree/useTree'

const genderAvatars = {
  female: femaleAvatar,
  male: maleAvatar,
  unknown: unknownAvatar,
}

export default function useImage(person) {
  const { portraits } = useTree()

  if (!person.id) return { avatar: genderAvatars[GENDER.unknown] }
  const standardizedGender = person?.gender?.toLowerCase()

  return { avatar: genderAvatars[standardizedGender] || genderAvatars.unknown, portrait: portraits[person.id] }
}
